import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'

// Components
import ThemeCardList from '@/components/pages/Mall/components/ThemeCardList'

// Constants

const cx = classnames.bind(styles)

interface IThemeCard {
  banner: string
  bannerM: string
  name: string
  picture: string
  themeId: number
  tips: string
}

interface IThemeCardList {
  themeCardList: IThemeCard[]
}

const ThemeHomePage = (props: IThemeCardList) => {
  const { themeCardList } = props

  return (
    <div className={cx('theme-hoem-page')}>
      <ThemeCardList themeCardList={themeCardList} />
    </div>
  )
}

export default ThemeHomePage
